import { connect } from 'react-redux'
import { AppState, Dispatch } from '../../../types'
import { notifyEvent, notifyIframeError } from '../../Iframe/actions'
import { Profile } from '../../../remote-api/CoreServicesRemoteApi'
import LogSearchIframe, { ValueProps, EventProps } from './LogSearchIframe'
import { selectors as authSelectors } from '../../../lifecycle/auth'

const mapStateToProps = (rootState: AppState): ValueProps => ({
  profile: (authSelectors.getProfile(rootState).getOrUndefined()) as Profile | undefined
})

const mapDispatch = (dispatch: Dispatch): EventProps => ({
  notifyEvent: (type: string, event: string, detail: any) => dispatch(notifyEvent(type, event, detail)),
  notifyError: (error: any) => dispatch(notifyIframeError(error))
})

export default connect(mapStateToProps, mapDispatch)(LogSearchIframe)
